import React from 'react';

const TacticalServiceHero = () => {
  return (
    <section className="relative min-h-[800px] flex flex-col items-center justify-center overflow-hidden pt-1 pb-20">
      {/* Background Glows (Greenish Flavor) */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-emerald-600/10 rounded-full blur-[120px] pointer-events-none" />

      {/* Main Content Container */}
      <div className="relative z-10 max-w-5xl w-full px-4 text-center">
        
        {/* Square Badge Icon (Green Accents) */}
        <div className="flex justify-center mb-[-40px] relative z-20">
          <div className="
            w-20 h-20 
            bg-[#061a14] 
            border border-emerald-500/50 
            rounded-2xl 
            rotate-45 
            flex items-center justify-center 
            shadow-[0_0_25px_rgba(16,185,129,0.3)] 
            transition-transform duration-500 
            hover:scale-110"
          >
            {/* Counter-rotate the image so the logo stays upright */}
            <img 
              src="/icon.png" 
              alt="Secuwall Icon" 
              className="w-10 h-10 object-contain -rotate-45" 
            />
          </div>
        </div>

        {/* Central Glassmorphism Card with Vanishing Borders */}
        <div 
          className="pt-24 pb-16 px-8 md:px-20 border-x border-t border-emerald-400/40 bg-white/[0.01] backdrop-blur-md rounded-t-[40px] relative"
          style={{
            /* This mask makes the borders vanish smoothly towards the bottom */
            WebkitMaskImage: 'linear-gradient(to bottom, black 70%, transparent 100%)',
            maskImage: 'linear-gradient(to bottom, black 70%, transparent 100%)'
          }}
        >
          {/* Top subtle green line accent */}
          <div className="absolute top-0 left-10 right-10 h-[2px] bg-gradient-to-r from-transparent via-emerald-500/50 to-transparent" />

          <p className="text-emerald-400 font-bold tracking-[0.4em] uppercase text-[10px] mb-6">
            SecuWall Technologies Limited
          </p>

          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-8 tracking-tight leading-tight">
            Know Your Weaknesses <br /> Before Attackers Do
          </h1>

          <p className="text-slate-300 text-lg leading-relaxed max-w-3xl mx-auto font-light">
            Our services help you uncover hidden vulnerabilities and strengthen your defenses before attackers strike. 
            From in-depth <span className="font-semibold text-emerald-400/90">Digital Forensics</span> and breach evidence recovery, 
            to ensuring <span className="font-semibold text-emerald-400/90">Compliance & Risk</span> alignment, and proactive  
            <span className="font-semibold text-emerald-400/90"> Vulnerability Assessment & Penetration Testing</span>, 
            we equip your organization to stay secure, resilient, and ahead of evolving threats.<br />
          </p>
        </div>
      </div>
      
      
      {/* CSS Utility Classes */}
      <style dangerouslySetInnerHTML={{ __html: `
        .clip-path-trapezoid {
          clip-path: polygon(0% 0%, 100% 0%, 88% 100%, 12% 100%);
        }
      `}} />
    </section>
  );
};

export default TacticalServiceHero;